import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHeart, FaSearch, FaUser, FaSignOutAlt } from "react-icons/fa";
import { fetchWishlist } from "../services/api";
import { jwtDecode } from "jwt-decode";
import "../styles/Navbar.css";

// Utility to get user ID from JWT token
function getUserId() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return decoded.id;
  } catch {
    return null;
  }
}

// Utility to get user info from JWT token
function getUserInfo() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return {
      id: decoded.id,
      username: decoded.username || 'User',
      email: decoded.email
    };
  } catch {
    return null;
  }
}

const Navbar = ({ mode, setMode }) => {
  const [wishlistCount, setWishlistCount] = useState(0);
  const [query, setQuery] = useState("");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const userInfo = getUserInfo();
  const isLoggedIn = !!token && !!userInfo;

  useEffect(() => {
    // Only fetch wishlist if logged in
    if (isLoggedIn) {
      fetchWishlist(userInfo.id, token)
        .then(items => setWishlistCount(items.length))
        .catch(() => setWishlistCount(0));
    } else {
      setWishlistCount(0);
    }
  }, [location, isLoggedIn, userInfo, token]);



  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/?search=${encodeURIComponent(query.trim())}`);
    }
    setQuery("");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setShowUserMenu(false);
    navigate("/");
    window.location.reload(); // Refresh to update state
  };



  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        🎮 <span style={{ color: "var(--accent)", fontWeight: "700" }}>Beast</span>
      </Link>
      
      <div className="navbar-links">
        <Link to="/" className={location.pathname === "/" ? "active" : ""}>
          Home
        </Link>
        <Link to="/trending" className={location.pathname === "/trending" ? "active" : ""}>
          Trending
        </Link>
        <Link to="/about" className={location.pathname === "/about" ? "active" : ""}>
          About
        </Link>
        
        {isLoggedIn ? (
          <>
            <Link to="/wishlist" className="wishlist-link" style={{ position: "relative" }}>
              <FaHeart style={{ color: "#a261e7", fontSize: "1.18rem", verticalAlign: "middle" }} />
              {wishlistCount > 0 && (
                <span className="wishlist-count">{wishlistCount}</span>
              )}
            </Link>
            

            
            {/* User Menu */}
            <div className="user-menu-container">
              <button 
                className="user-menu-btn"
                onClick={() => setShowUserMenu(!showUserMenu)}
                aria-label="User menu"
              >
                <FaUser />
                <span className="username">{userInfo.username}</span>
              </button>
              
              {showUserMenu && (
                <div className="user-dropdown">
                  <div className="user-info">
                    <h3>{userInfo.username}</h3>
                    <p>{userInfo.email}</p>
                  </div>
                  <div className="user-menu-items">
                    <Link to="/profile" onClick={() => setShowUserMenu(false)}>
                      <FaUser /> Profile
                    </Link>
                    <Link to="/wishlist" onClick={() => setShowUserMenu(false)}>
                      <FaHeart /> Wishlist
                    </Link>
                    <button className="logout-btn" onClick={handleLogout}>
                      <FaSignOutAlt /> Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <Link to="/login" className="auth-link">Login</Link>
            <Link to="/signup" className="auth-link signup">Sign Up</Link>
          </>
        )}
      </div>

      <div className="navbar-search">
        <form onSubmit={handleSearch} style={{ display: "flex", alignItems: "center" }}>
          <input
            className="navbar-search-input"
            type="text"
            placeholder="Search games..."
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
          <button className="navbar-search-btn" type="submit" aria-label="Search">
            <FaSearch />
          </button>
        </form>
      </div>

      <button
        onClick={() => setMode(mode === "dark" ? "light" : "dark")}
        className="theme-toggle-btn"
        aria-label={`Switch to ${mode === "dark" ? "light" : "dark"} mode`}
      >
        {mode === "dark" ? "🌙 Dark" : "☀️ Light"}
      </button>
    </nav>
  );
};

export default Navbar;
